import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { Dynamic, type DynamicAction } from '@shared/registry';

import type { SummaryCardConfig } from './summary-card.types';

@Component({
  selector: 'app-summary-card',
  templateUrl: './summary-card.html',
  imports: [Dynamic],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SummaryCard {
  readonly config = input.required<SummaryCardConfig>();
  readonly disabled = input<boolean>(false);

  readonly action = output<DynamicAction>();

  protected readonly titleConfig = computed(() => ({
    text: this.config().title,
    size: 'xl' as const,
    fontWeight: 'semibold' as const,
    color: 'var(--summarycard-title-color)',
  }));

  protected readonly supportingText1Config = computed(() => {
    const text = this.config().supportingText1;
    if (!text) return null;
    return {
      text,
      size: 'base' as const,
      fontWeight: 'semibold' as const,
      color: 'var(--summarycard-supporting-text-1color)',
    };
  });

  protected readonly supportingText2Config = computed(() => {
    const text = this.config().supportingText2;
    if (!text) return null;
    return {
      text,
      size: 'base' as const,
      fontWeight: 'semibold' as const,
      color: 'var(--summarycard-supporting-text-2color)',
    };
  });

  protected readonly buttons = computed(() => this.config().buttons ?? []);

  protected onButtonClick(action: DynamicAction | undefined): void {
    if (action) {
      this.action.emit(action);
    }
  }
}
